import { NUMBERED_LIST_TYPE } from 'ricos-content';
import { Node_Type } from 'ricos-schema';
import type { TiptapEditorPlugin } from 'ricos-types';
import { createShortcut } from 'ricos-types';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';

import { orderedList } from './extension';
import OrderedListIcon from './OrderedListIcon';

export const pluginOrderedList: TiptapEditorPlugin = {
  type: Node_Type.ORDERED_LIST,
  config: {},
  shortcuts: [
    createShortcut({
      name: Node_Type.ORDERED_LIST,
      description: 'ShortcutsSheet_Formatting_NumberedList',
      keys: { macOs: 'Meta+Shift+7', windows: 'Ctrl+Shift+7' },
      command({ editorCommands }) {
        editorCommands.setBlockType(NUMBERED_LIST_TYPE);
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  tiptapExtensions: [orderedList],
  textButtons: [
    {
      id: Node_Type.ORDERED_LIST,
      type: 'toggle',
      presentation: {
        dataHook: 'textBlockStyleButton_Numberedlist',
        tooltip: 'OrderedListButton_Tooltip',
        icon: OrderedListIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_ORDERED_LIST,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED,
      },
      command:
        ({ editorCommands }) =>
        () => {
          editorCommands.setBlockType(NUMBERED_LIST_TYPE);
          return true;
        },
    },
  ],
};
